import TwoColumnsAlternate from "./_components/two-columns-alternate";

export default TwoColumnsAlternate;
